export class NotImplementedError extends Error {
    constructor() {
        super('Not implemented.');
    }
}
export class OutOfRangeError extends Error {
    constructor(index) {
        super(`Index out of range: ${index}`);
    }
}
export class NotReadableError extends Error {
    constructor() {
        super("readable flag need to be true.");
    }
}
export function getErrorMsg(err) {
    if (err != null && typeof err === "object") {
        let str;
        for (let k in errorFields) {
            str = err[errorFields[k]];
            if (str != null)
                return parseError(str);
        }
    }
    return parseError(err);
}
function parseError(err) {
    if (typeof (err) === "number")
        return `error code=${err}`;
    else if (typeof (err) !== "string")
        return "error! " + err;
    else
        return err;
}
const errorFields = ["errMsg", "errorMessage", "message", "reason", "error", "errCode", "statusCode"];
